import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../Modal/Modal';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import SecondaryButton from '../SecondaryButton/SecondaryButton';
import SmallCheckBox from '../SmallCheckBox/SmallCheckBox';

type Props = {
  bodyTranslationKey: string;
  onYes: () => void;
  onNo: (dontAskUntilNextMonth: boolean) => void;
  onClose: () => void;
};

function SmsConfirmModal({ bodyTranslationKey, onYes, onNo, onClose }: Props) {
  const { t } = useTranslation();
  const [dontAskChecked, setDontAskChecked] = useState(false);

  return (
    <Modal
      modalTitle="calendar.sms_confirm.title"
      canClose
      onClose={onClose}
    >
      <>
        <p className="py-3">{t(bodyTranslationKey)}</p>
        <div className="mt-4 mb-2">
          <SmallCheckBox
            label="calendar.sms_confirm.dont_ask_until_next_month"
            defaultValue={false}
            onChange={(e) => setDontAskChecked(e.target.checked)}
          />
        </div>
        <div className="flex justify-center gap-3 mt-5">
          <SecondaryButton
            text={t('calendar.sms_confirm.no') ?? ''}
            fn={() => onNo(dontAskChecked)}
          />
          <PrimaryButton
            text={t('calendar.sms_confirm.yes') ?? ''}
            fn={onYes}
          />
        </div>
      </>
    </Modal>
  );
}

export default SmsConfirmModal;
